'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.sendAnalyticsEvents = sendAnalyticsEvents;

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// this eslint disable can be removed when another module is exported from this file
/* eslint-disable import/prefer-default-export */

/**
 * @definition updates missing paramaters from event payload with values of undefined
 * @param {Object} payload
 * @example
 * old payload: {action: 'add', label: 'new'}
 * new payload: {action: 'remove' }
 * returns: {action: 'remove', label: undefined}
 */
function transformPayload(payload) {
  var newPayload = _extends({}, payload);
  var latestBCEvent = [].concat(_toConsumableArray(window.dataLayer)).reverse().find(function (event) {
    return event.payload;
  });

  // compares the latestBCEvent payload keys to the upcoming event's payload keys
  if (latestBCEvent) {
    Object.keys(latestBCEvent.payload).forEach(function (key) {
      // if a key is missing on the upcoming payload, define it as undefined; this prevents the new payload from using the old payload values
      if (!Object.prototype.hasOwnProperty.call(newPayload, key)) {
        newPayload[key] = undefined;
      }
    });
  }
  return newPayload;
}

/**
 * @definition pushes current analytic event to data layer for tracking
 * @param {Array} analytics holds events array which holds objects with following shape: { event, payload }
 */
function sendAnalyticsEvents(analytics) {
  if (analytics && analytics.events) {
    analytics.events.forEach(function (event) {
      if (event.event) {
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push({
            event: event.event,
            payload: transformPayload(event.payload)
          });
        }
      }
    });
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-analytics/lib/index.js
// module id = 142
// module chunks = 1